import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import store from '../store';
import ACTIONS from '../store/actions';
import MODAL_COMPONENTS from './variants';
/**
 * Opens a built in modal or a custom one registered through EcrionProvider
 * @param {import('./types').ModalOpenIntention} options
 */

export var open = function open(options) {
  return store.dispatch({
    type: ACTIONS.MODAL_OPEN,
    payload: {
      modalType: options.type,
      modalProps: _objectSpread({}, options.props, {
        onClose: function onClose(e) {
          if (options.props && typeof options.props.onClose === 'function') options.props.onClose(e);
          close();
        }
      })
    }
  });
};
export var close = function close() {
  return store.dispatch({
    type: ACTIONS.MODAL_CLOSE
  });
};
/**
 * @param {{ type: string; component: React.ComponentType}[]} modals Additional modals to register
 */

export var register = function register(modals) {
  Object.keys(modals).map(function (modalType) {
    return addModal(modalType, modals[modalType]);
  });
};
/**
 *
 * @param {string} modalType Type of the modal. Used with `open`
 * @param {React.ComponentType} ModalComponent The Component to render.
 * The component will receive `onClose` as a prop
 */

var addModal = function addModal(modalType, ModalComponent) {
  MODAL_COMPONENTS[modalType] = ModalComponent;
};